/**
 * Assignment Context Component
 * Shows breakdown of assigned vs self-paced activities
 */

import { Box, Paper, Typography } from '@mui/material'
import { Assignment } from '@mui/icons-material'
import { useTheme } from '@mui/material/styles'
import { AssignmentContext } from '../../types'

interface AssignmentContextProps {
  data: AssignmentContext
}

export default function AssignmentContextComponent({
  data,
}: AssignmentContextProps) {
  let theme = useTheme()

  let contextItems = [
    {
      label: 'Assigned Activities',
      count: data.assignedActivities,
      percentage: data.assignedPercentage,
      color: theme.palette.analyticsColors.assignedActivities,
    },
    {
      label: 'Unassigned Activities',
      count: data.selfPacedActivities,
      percentage: data.selfPacedPercentage,
      color: theme.palette.analyticsColors.selfPacedLearning,
    },
  ]

  return (
    <Paper sx={{ p: 3 }}>
      <Typography
        variant="h6"
        sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <Assignment />
        Assignment Context
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {contextItems.map((item, index) => (
          <Box key={index}>
            <Box
              sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}
            >
              <Typography variant="body2">{item.label}</Typography>
              <Typography variant="body2" color="text.secondary">
                {item.count} ({Math.round(item.percentage)}%)
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                height: 8,
                bgcolor: 'background.paperDark',
                borderRadius: 1,
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  width: `${item.percentage}%`,
                  height: '100%',
                  bgcolor: item.color,
                  transition: 'width 0.3s ease',
                }}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Paper>
  )
}
